import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FooterSection = styled(Box)(({ theme }) => ({
  minHeight: '22.5rem',
  backgroundColor: theme.palette.primary.light,
  [theme.breakpoints.down(theme.breakpoints.values.md)]: {
    minHeight: '45rem'
  }
}));
